import React from "react";
import { Button, Typography } from "@c4c-web/ui";
import { BriefcaseIcon, HouseIcon, PinIcon, UserIcon } from "@c4c-web/icons";
import type { IAddress, TranslationFn } from "../../../types";
import { EAddressType } from "../../../constants";
import { phoneNumberShaper, filterAddressParts } from "../../../utils";

interface IConfirmAddressSummary {
  address: IAddress;
  onOpenChange: (value: boolean) => void;
  openAddressForm?: (value: boolean) => void;
  t: TranslationFn;
}

const IconMap: Record<string, JSX.Element> = {
  home: <HouseIcon variant="thin" />,
  office: <BriefcaseIcon variant="thin" />,
  other: <PinIcon variant="thin" />,
};

export const ConfirmAddressSummary: React.FC<IConfirmAddressSummary> = ({
  address,
  onOpenChange,
  openAddressForm,
  t,
}): JSX.Element => {
  const getAddressIcon = (): JSX.Element => {
    const label = address.addressLabel?.toLowerCase();
    if (label === EAddressType.HOME || label === EAddressType.OFFICE) {
      return IconMap[label];
    }
    return IconMap.other;
  };

  const { addressLabel, emirate, town, firstName, countryCode, phone } =
    address;

  const label =
    addressLabel?.toLowerCase() === EAddressType.HOME ||
    addressLabel?.toLowerCase() === EAddressType.OFFICE
      ? t(`addressJourney.addressForm.${addressLabel.toLowerCase()}`)
      : address.otherAddressType || addressLabel;

  const filteredArea = filterAddressParts(emirate ? emirate : town);

  return (
    <div className="flex flex-col items-center justify-between gap-md rounded-2xl border border-solid border-gray-100 p-md">
      <div className="flex w-full items-center gap-sm">
        <div>{getAddressIcon()}</div>
        <div className="flex flex-col">
          <Typography variant="lg" weight="bold">
            {label}
          </Typography>
          <Typography>{filteredArea}</Typography>
        </div>
      </div>

      <div className="flex w-full items-center gap-sm">
        <UserIcon variant="thin" />
        <div className="flex flex-col">
          <Typography variant="lg" weight="bold">
            {firstName}
          </Typography>
          <Typography>
            {countryCode} {phoneNumberShaper(phone ?? "")}
          </Typography>
        </div>
      </div>

      <Button
        className="w-full rounded-lg"
        onClick={() => {
          onOpenChange(false);
          openAddressForm?.(true);
        }}
        shape="square"
        size="md"
        variant="secondary"
      >
        {t("addressJourney.change")}
      </Button>
    </div>
  );
};
